import { Component, Input, OnInit } from "@angular/core";
import { Global } from "../../../../global";
import * as $ from "jquery";
import Swal from "sweetalert2";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { FileUploadService } from "src/app/service/fileService";
import * as moment from "moment";
@Component({
  selector: "app-declaration-list",
  templateUrl: "./declaration-list.component.html",
  styleUrls: ["./declaration-list.component.css"],
})
export class DeclarationListComponent implements OnInit {
  @Input() listaAbaDeclaracao: any = [];
  declaracao: any = {};
  @Input() prontuario: any = [];
  dadosImpresso: any;
  dataHoje: any = "";
  fileUrl: SafeUrl;
  constructor(
    private global: Global,
    private sanitizer: DomSanitizer,
    private fileUploadService: FileUploadService,
    public service: ApiService,
    private authService: AuthService
  ) {}

  ngOnInit() {}

  visualizarDeclaracao(declaracao) {
    this.declaracao = declaracao;

    $("#modalVisualizarDeclaracao").toggleClass("show");
    $("#modalVisualizarDeclaracao").css("display", "block");
  }

  fecharModal = () => {
    $("#modalVisualizarDeclaracao").toggleClass("show");
    $("#modalVisualizarDeclaracao").css("display", "none");
  };

  imprimirDado(item: any) {    
    var tipo_declaracao = "";
    if (item.tipo_declaracao === "LIVRE") {
      tipo_declaracao = "DECLARACAO_LIVRE.frx";
    } else if (item.tipo_declaracao === "PADRAO") {
      tipo_declaracao = "DECLARACAO_PADRAO.frx";
    }

    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .PostImpresso(`Documento/impresso-pdf/` + tipo_declaracao, [
        {
          nome: "id",
          valor: item.id.toString(),
        },
      ])
      .then((res) => {
        if (res) {
          var link: any = res;
          Swal.close();
          window.open(link, "_blank");
        }
      });
  }
  enviarWhatsApp(item: any) {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    var tipoDeclaracaoImpresso: Number = 8;
    if (item.tipo_declaracao == "LIVRE") tipoDeclaracaoImpresso = 7;

    this.service
      .Get(
        `Documento/impresso/Whatsapp/ ${item.id}?atendimento_id=${this.prontuario.atendimento_id}&tipo_documento=${tipoDeclaracaoImpresso}`
      )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: "Declaração enviada com sucesso!",
        }).then(() => {
          Swal.close();
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao enviar a declaração!",
        }).then(() => {
          Swal.close();
        });
      });
  }
}
